/* RESPONSIBLE TEAM: team-workflows */
import type MessengerApp from 'embercom/models/operator/visual-builder/step/messenger-app';
import StepConfig, { type StepConfigParams } from '../step';

export default class MessengerAppConfiguration extends StepConfig {
  declare step: MessengerApp;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/messenger-app',
      ...params,
    });
  }
}
